import React  from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faEnvelope } from '@fortawesome/free-solid-svg-icons';
// import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";


export default function Topnavbar() {
  // const navigate=useNavigate();
  return (
    <div style={{
      backgroundColor: '#24246E',
      minHeight: '45px',
      width: '100%',
    }}>
      <div className="container ">
        <div className="row h-100 align-items-center justify-content-between">
          {/* Left side links */}
          <div className="col-auto">
            <div className="d-flex align-items-center mt-2 flex-wrap justify-content-center justify-content-md-start">
              {/* <a 
                href="#enquiry" 
                className="text-white text-decoration-none fw-medium px-2 px-sm-3"
                style={{ fontSize: '14px' }}
              >
                Project Enquiry
              </a>
              <span className="text-white d-none d-sm-inline">|</span> */}
              <Link 
  to="/Careers"
  className="text-white text-decoration-none fw-medium px-2 px-sm-3"
  style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}
>
  Careers
</Link>

<span className="text-white d-none d-sm-inline">|</span>

<Link 
  to="/blogs"
  className="text-white text-decoration-none fw-medium px-2 px-sm-3"
  style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}
>
  Blog
</Link>

            </div>
          </div>

          {/* Right side email */}
          <div className="col-auto">
            <div className="d-flex mt-2 align-items-center justify-content-center justify-content-md-end">
              <a 
                href="mailto:info@safprotech.com"
                className="text-white text-decoration-none fw-medium d-flex align-items-center px-2 px-sm-3"
                style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}
              >
                <FontAwesomeIcon icon={faEnvelope} className='mx-1 fs-6' style={{color:"#2663eb"}}/>
                <span className="d-none d-md-inline">info@safprotech.com</span>
                <span className="d-inline d-md-none d-sm-inline">Email</span>

                {/* <span className="d-inline d-sm-none">Email</span> */}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}